import { useEffect } from 'react';
import type { AnalyticsData } from './types';

interface Props {
  gtmId: string;
  isSandbox: boolean;
  analyticsData: AnalyticsData;
}

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export function Gtm({ gtmId, isSandbox, analyticsData }: Props) {
  useEffect(() => {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    if (isSandbox) {
      return;
    }

    // Push user data if available
    if (analyticsData?.wuid) {
      window.dataLayer.push(analyticsData);
    }

    // Google Tag Manager
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.prepend(script);

    return () => {
      if (!isSandbox) {
        document.head.removeChild(script);
      }
    };
  }, [isSandbox, analyticsData, gtmId]);

  if (isSandbox) {
    return null;
  }

  return (
    <noscript>
      <iframe
        src={`//www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      />
    </noscript>
  );
}
